import {observable} from "mobx";
import api from "../../Services/Api";

class OrderPageWidgetStore {
    @observable contextKey?: string;
    @observable orderHrefId?: string;
    @observable orderId?: string;
    @observable isLoading: boolean = false;

    async init(contextKey: string, orderHrefId: string) {
        this.setIsLoading(true);
        this.contextKey = contextKey;
        this.orderHrefId = orderHrefId;
        const authSuccess = await api.auth(contextKey);
        if (authSuccess) {
            this.orderId = orderHrefId;
        }
        this.setIsLoading(false);
    }

    cleanup() {
        this.contextKey = undefined;
        this.orderHrefId = undefined;
        this.orderId = undefined;
    }

    private setIsLoading(isLoading: boolean) {
        this.isLoading = isLoading;
    }
}

const orderPageWidgetStore = new OrderPageWidgetStore();
export default orderPageWidgetStore;